export default __webpack_public_path__ + "static/media/icaew_l.ff0f523d.jpg";